/**
 * Stable underground cell placement per entrance id (avoids overlapping instances).
 * @param {string} entranceId
 * @param {{ cellBaseY: number; cellSpacing: number }} config
 */
export function interiorWorldOrigin(entranceId, config) {
  let h = 2166136261;
  for (let i = 0; i < entranceId.length; i += 1) {
    h ^= entranceId.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  const slot = h >>> 0;
  const cols = 8;
  const index = slot % 64;
  const spacing = config.cellSpacing;
  return {
    x: (index % cols) * spacing,
    y: config.cellBaseY,
    z: Math.floor(index / cols) * spacing,
  };
}

/**
 * World XZ used for chunk streaming while the player is inside an interior.
 * @param {number} doorRotY
 */
export function exteriorExitOffset(doorRotY, distance = 1.55) {
  return {
    x: Math.sin(doorRotY) * distance,
    z: Math.cos(doorRotY) * distance,
  };
}
